var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKuwait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.756 26.9564C39.5599 24.7898 40 22.4464 40 19.9999C40 17.5535 39.5599 15.2101 38.756 13.0435L20 11.3043L1.24398 13.0435C0.440078 15.2101 0 17.5535 0 19.9999C0 22.4464 0.440078 24.7898 1.24398 26.9564L20 28.6956L38.756 26.9564Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 39.9999C28.5993 39.9999 35.9303 34.5724 38.7561 26.9564H1.24402C4.06996 34.5724 11.4007 39.9999 20.0001 39.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 -6.10352e-05C11.4007 -6.10352e-05 4.06996 5.42744 1.24402 13.0435H38.7561C35.9303 5.42744 28.5993 -6.10352e-05 20.0001 -6.10352e-05Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85785 5.85773C-1.95262 13.6682 -1.95262 26.3315 5.85785 34.1421C7.89652 32.1034 9.88637 30.1136 13.0435 26.9565V13.0434L5.85785 5.85773Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuwait);
export default __webpack_public_path__ + "static/media/kuwait.619ee8464e56fa97067916f16584a8df.svg";
export { ForwardRef as ReactComponent };